import { useRef, useEffect } from "react";
import { snowUtil } from "../../../utils/snowUtil";

const useSnowy = (hasWinterWheel: boolean, showWinterWheel: boolean): void => {
    // setup snow animation when the winterwheel is shown
    const snow = useRef<any>(false);
    useEffect(() => {
        // initialize animation when the car has a winterwheel
        if (hasWinterWheel && !snow.current) {
            snow.current = snowUtil();
        }

        // stop / start the animation when the user toggles the winterwheel
        if (snow.current) {
            if (showWinterWheel) {
                snow.current.start();
            } else {
                snow.current.stop();
            }
        }
    }, [hasWinterWheel, showWinterWheel]);
};

export default useSnowy;
